/**
 * Cookies that are automatically checked and stored class
 */
export default class CookiesAutomatic {

  /**
   * @constructor
   */
    constructor()
    {
        this.init();
    }

    init()
    {
        let locale = $('meta[name="country"]').attr('content');

        // remove not active locations from recently viewed
        $.ajax({
            headers: {
                'X-App-Locale': locale
            },
            url: window.origin+'/cookie/reset',
            method: 'POST',
            success: function() {
                // set new cookie for current location
                $('[data-cookies-recently]').each((i, e) => {
                    $.ajax({
                        headers: {
                            'X-App-Locale': locale
                        },
                        url: window.origin+'/cookie/set',
                        method: 'POST',
                        data: {
                            'locationID': $(e).val()
                        },
                    });
                })
            }
        });
    }
}